import { Box, Button, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector, RootState } from '../../store';
import { useNavigate } from 'react-router-dom';

// icon
import AddIcon from '@mui/icons-material/Add';
import Toast from '../../components/atoms/toast';
import SearchCertificateSearch from '../../components/molecules/searchCertificate/SearchCertificateSearch';
import SearchCertificateTable from '../../components/molecules/searchCertificate/SearchCertificateTable';
import { getSearchCertificate } from '../../store/feature/structureCaCrls';
import ListDataSkeleton from '../../components/template/skeleton/ListDataSkeleton';

const SearchCertificate = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [params, setParams] = useState<object>({
    isUser: "10000000" // FALSE
  });
  const [defaultValue, setDefaultValue] = useState({});
  const { dataSearchCertificate, isLoadingCertCAandCRL } = useAppSelector((state: RootState) => state.cerCA);

  useEffect(() => {
    dispatch(getSearchCertificate(params))
  }, [params]);

  return (
    <ListDataSkeleton isLoading={isLoadingCertCAandCRL} isLoadingEvent={false} colCount={6} titleWidth={'275px'} contentHeight={650}>
      <Typography variant="h3" fontFamily="Open Sans" sx={{ marginY: '20px' }}>
        Search Certificate
      </Typography>
      <SearchCertificateSearch
        params={params}
        setParams={setParams}
      />
      <SearchCertificateTable
        data={dataSearchCertificate}
        params={params}
        setParams={setParams}
        defaultValue={defaultValue}
        setDefaultValue={setDefaultValue}
      />
      {/* <Toast
        severity="success"
        open={msgSccsFGr !== ''}
        handleClose={handleCloseToast}
        message={msgSccsFGr}
      /> */}
    </ListDataSkeleton>
  );
};

export default SearchCertificate;
